"use client";

import Box from "@mui/material/Box";
import type { PayloadLegalLinksConfig } from "@portal/app/_server/services/formFunnel/payloadTypes";
import { PageLinks } from "./PageLinks";

/** Resolve the current global at render time instead of copying legal text into each page. */
export function PageLegalLinks({
  config,
  inert = true,
  readOnly = false,
}: {
  config?: PayloadLegalLinksConfig | null;
  inert?: boolean;
  readOnly?: boolean;
}) {
  const links = config?.enabled
    ? (config.links ?? []).filter((link) => link.label?.trim() && link.url?.trim())
    : [];
  if (!links.length) {
    return readOnly ? null : (
      <Box sx={{ fontSize: 12, color: "text.secondary", textAlign: "center", py: 2 }}>
        Site-wide legal links appear here when enabled.
      </Box>
    );
  }
  return (
    <Box sx={{ maxWidth: 600, mx: "auto", px: { xs: 2, sm: 3 }, mt: 4, mb: 2 }}>
      <PageLinks
        label="Legal links"
        appearance="legal"
        align="center"
        links={links.map((link) => ({ label: link.label, url: link.url, newTab: true }))}
        inert={inert}
      />
    </Box>
  );
}
